import React from 'react';
import { useFilter } from '../contexts/FilterContext';
import { FloatingFilterModal } from './FloatingFilterModal';

export const GlobalFloatingFilter: React.FC = () => {
  const { showFilter, filterData } = useFilter();

  if (!showFilter || !filterData) return null;

  return (
    <FloatingFilterModal
      subjects={filterData.subjects}
      chapters={filterData.chapters}
      activeSubject={filterData.activeSubject}
      activeChapter={filterData.activeChapter}
      activeDifficulty={filterData.activeDifficulty}
      onSubjectChange={filterData.onSubjectChange}
      onChapterChange={filterData.onChapterChange}
      onDifficultyChange={filterData.onDifficultyChange}
      questionCount={filterData.questionCount}
      totalQuestions={filterData.totalQuestions}
    />
  );
};